module.exports = __webpack_public_path__ + "static/media/picasso-10.4411ab08.jpeg";